import { configureStore } from "@reduxjs/toolkit";
import companyReducer from "./companySlice";
import authReducer, { validateToken } from "./authSlice";
import authv2Reducer from "./authv2Slice";
import installationReducer from "./installationSlice";
import statementsReducer from "./document/statementsSlice";
import contractsReducer from "./document/contractsSlice";
import completedAgreementsReducer from "./document/completedAgreements";
import signedMandatesReducer from "./document/signedMandatesSlice";
import switchConfirmationsReducer from "./document/switchConfirmationsSlice";
import eocConfirmationsReducer from "./document/eocConfirmationsSlice";
import allCompanyReducer from "./allCompanySlice";
import themeReducer from "./themeSlice";
import companyServiceSliceReducer from "./companyServiceSlice";
import userReducer from "./userSlice";
import companyPortfolioReducer from "./companyPortfolioSlice";
import partnerReducer from "./partnerSlice";
import pvCurtailmentReducer from "./pvCurtailment";
import bessOnboardingReducer from "./bessOnboarding";
import bessResignReducer from "./bessResignSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    authv2: authv2Reducer,
    selectedCompany: companyReducer,
    installation: installationReducer,
    statements: statementsReducer,
    contracts: contractsReducer,
    completedAgreements: completedAgreementsReducer,
    signedMandates: signedMandatesReducer,
    switchConfirmations: switchConfirmationsReducer,
    eocConfirmations: eocConfirmationsReducer,
    allCompany: allCompanyReducer,
    theme: themeReducer,
    companyServiceSlice: companyServiceSliceReducer,
    user: userReducer,
    companyPortfolio: companyPortfolioReducer,
    partner: partnerReducer,
    pvCurtailment: pvCurtailmentReducer,
    bessOnboarding: bessOnboardingReducer,
    bessResign: bessResignReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

store.dispatch(validateToken());

export default store;
